/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return d
}

export { color };
//# sourceMappingURL=color.js.map
